/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { makeAutoObservable } from 'mobx';

import { processApplicationStore, currentDiagramStore, projectStore } from 'stores';
import createPermission from 'utils/createPermission';
import { BPMN } from 'utils/constants';

class DeploymentPermissionsStore {
  isAdminOrEditor = false;

  constructor() {
    makeAutoObservable(this);
  }

  init() {
    const project = projectStore.project?.id ? projectStore.project : currentDiagramStore.state.project;
    const permission = createPermission(project?.permissionAccess);
    this.isAdminOrEditor = permission.is(['ADMIN', 'WRITE']);
  }

  reset() {
    this.isAdminOrEditor = false;
  }

  get weAreInBPMNDiagramOrInProcessApplication() {
    return currentDiagramStore.state.diagram?.type === BPMN || processApplicationStore.fromAProcessApplication;
  }

  get isAllowedToStartInstance() {
    return this.isAdminOrEditor && this.weAreInBPMNDiagramOrInProcessApplication;
  }

  get isExternalApplicationLinksMenuItemPresent() {
    return false;
  }

  get isDeployOrStartInstanceButtonPresent() {
    return this.isAdminOrEditor;
  }
}

export default new DeploymentPermissionsStore();
